import React, { Component } from 'react';
import Uppy from '@uppy/core';
import DragDrop from '@uppy/drag-drop';
import ProgressBar from '@uppy/progress-bar';
import Transloadit from "@uppy/transloadit"
import Avatar from 'react-avatar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import _ from 'lodash';
import '@uppy/core/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import './AvatarUploader.scss';

const NOTIFY_URL = `${process.env.REACT_APP_TRANSLOADIT_NOTIFY_URL_AVATAR}/users/v1/avatar-notification`;

class AvatarUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      avatarUrl: null
    }

    this.uppy = null;
  }

  static getDerivedStateFromProps(props, state) {
    const avatarUrl = _.get(props, "cognitoUser.attributes['custom:avatar_large']", null);
    if (avatarUrl !== state.avatarUrl) {
      return { avatarUrl };
    }

    return null;
  }

  componentDidMount() {
    this.uppy = new Uppy({ debug: false, autoProceed: true });
    this.uppy
      .use(DragDrop, { target: '.UppyDragDrop' })
      .use(ProgressBar, { target: '.UppyDragDrop-Progress', hideAfterFinish: true })
      .use(Transloadit, {
        waitForMetadata: true,
        getAssemblyOptions: async (file) => {
          let templateId = process.env.REACT_APP_TEMPLATE_AVATAR_PROCESS;
          const tokens = await this.props.Auth.currentSession();

          return {
            params: { 
              auth: { key: process.env.REACT_APP_TRANSLOADIT_AUTH_KEY},
              template_id: templateId,
              notify_url: NOTIFY_URL
             },
            // Pass through the fields you need:
            fields: {
              tenantId: this.props.user.tenantId, // TODO grab from session user.tenantId
              userId: this.props.cognitoUser.username, // TODO grab from session user.userId
              accessToken: tokens.accessToken.jwtToken
            },
          }
        }
      });

    this.uppy.on('file-added', file => {
      this.setState({ avatarUrl: null });
    });

    this.uppy.on('complete', result => {
      if (result.failed.length === 0) {
        setTimeout(() => {
          this.props.getCurrentCognitoUser();
          this.forceUpdate();
        }, 10000);
        toast.success('Profile image uploaded successfully', {
          position: toast.POSITION.TOP_RIGHT
        });
      } else {
        toast.error('Failed to upload profile image. Please try again later', {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    });

    if (this.props.cognitoUser) {
      this.setState({ avatarUrl: _.get(this.props, "cognitoUser.attributes['custom:avatar_large']", null) });
    }
  }

  onChangeAvatar = () => {
    const uploadBtn = document.querySelector('.profile-picture .uppy-DragDrop-label');
    uploadBtn.click();
  }

  render() {
    // const newAvatar = _.get(this.props, "cognitoUser.attributes['custom:avatar_large']", null);
    const { avatarUrl } = this.state;
    
    return (
      <div className="profile-picture">
        {/* {newAvatar ? <img className="UppyDragDrop" src={newAvatar} width="96px" height="96px" style={{ borderRadius: "50%" }} /> */}
          <Avatar
            className="ml-1 UppyDragDrop"
            name={_.get(this.props, "cognitoUser.attributes[name]", _.get(this.props, "cognitoUser.challengeParam.userAttributes[name]"))}
            size={96}
            round={true}
            color="white"
            fgColor="pink"
            src={avatarUrl}
          />
        {/* } */}
        <FontAwesomeIcon icon={faCamera} onClick={this.onChangeAvatar} />
        <div className="UppyDragDrop-Progress" />
      </div>
    );
  }
}

export default AvatarUploader;
